/// <amd-module name="Build/Admin/Common/Components/Owner" />
import * as React from "react";

import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { getIdentityImageUrl } from "VSS/Platform/Identity";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";

import { VssPersona } from "VSSUI/VssPersona";

import { getPoolOwnerDisplayName } from "Build/Admin/Common/TaskAgentPoolUtils";

export interface IOwnerProps {
    identity: IdentityRef;
    hidePersona?: boolean;
}

export class Owner extends VssComponent<IOwnerProps> {

    constructor(props: IOwnerProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <div className="pipelines-owner flex-row flex-center">
                {
                    !this.props.hidePersona &&
                    <VssPersona
                        cssClass="owner-persona"
                        size="medium"
                        showInitialsOnImageError={true}
                        identityDetailsProvider={{
                            getDisplayName: () => {
                                return getPoolOwnerDisplayName(this.props.identity);
                            },
                            getIdentityImageUrl: (size: number) => {
                                return getIdentityImageUrl(this.context.pageContext, this.props.identity);
                            }
                        }}
                    />
                }
                <span className="display-name">{getPoolOwnerDisplayName(this.props.identity)}</span>
            </div>
        );
    }
}
